<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>OT Allowance (Hour Wise)</h5>
            </div>
            <div class="basic-contbox">
                <div class="label">
                    <label nz-checkbox [(ngModel)]="checked">Select All (Allow Ot)</label>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>OT Multiply</h5>
                    </div>
                    <div class="emp-input dep-input-box">
                        <input nz-input placeholder="OT Multiply" [(ngModel)]="value" />
                        <a href="javascript:void(0);" class="dep-btn"><span><i nz-icon nzType="plus-circle" nzTheme="outline"></i></span> Apply</a>
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Set Same Hr</h5>
                    </div>
                    <div class="emp-input dep-input-box">
                        <input nz-input placeholder="Set Same Hr" [(ngModel)]="value" />
                        <a href="javascript:void(0);" class="dep-btn"><span><i nz-icon nzType="plus-circle" nzTheme="outline"></i></span> Apply</a>
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>From</h5>
                    </div>
                    <div class="emp-input">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>To</h5>
                    </div>
                    <div class="emp-input">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Punch ID</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Punch ID" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Employee</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Employee" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="grace-btnbox">
                    <ul>
                        <li><a href="javascript:void(0);"><span><i nz-icon nzType="search" nzTheme="outline"></i></span> Search</a></li>
                        <li><a href="javascript:void(0);"><span><i nz-icon nzType="clear" nzTheme="outline"></i></span> Clear</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="basic-details basic-details3">
            <div class="tabledata">
                <!-- <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div> -->
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Emp Code</th>
                            <th>Employee Name</th>
                            <th>Attn Date</th>
                            <th>Attn OT Hrs</th>
                            <th>Allow?</th>
                            <th>Allowed OT</th>
                            <th>First In</th>
                            <th>Last Out</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>
